var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('iframe',{attrs:{"src":("https://lab.solenagreen.com/area/" + (this.soilArea) + "/sampleProfileSampler")}})])}
var staticRenderFns = []

export { render, staticRenderFns }